import { Component, effect, input, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Question } from '@empathy/survey-core';

import { CopyCardsConfirmationComponent } from './copy-cards-confirmation/copy-cards-confirmation.component';
import { QuestionCardForm } from '../../../models/type-forms/question-card-form.model';
import { IQuestionCardForm } from '../../../models/type-forms/question-form-group.interface';
import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-cards-settings',
  templateUrl: 'cards-settings.component.html',
  styleUrls: ['./cards-settings.component.scss', './_cards-settings-theme.component.scss']
})
export class CardsSettingsComponent implements OnInit {
  activeQuestion = input<FormGroup>();

  questionToCopyFromCtrl = new FormControl();
  questionsToCopyCardsFrom: Question[] = [];

  constructor(
    private dialog: MatDialog,
    private surveyEditorService: SurveyEditorService
  ) {
    effect(() => {
      if (this.activeQuestion()) {
        this.questionsToCopyCardsFrom = this.surveyEditorService
          .surveyEditor$()
          .allAllowedCopyCardsTypeQuestions.filter((q) => q.id !== this.activeQuestion().value.id);
      }
    });
  }

  get cards(): FormArray<FormGroup<IQuestionCardForm>> {
    return this.activeQuestion().get('cards') as FormArray<FormGroup<IQuestionCardForm>>;
  }

  ngOnInit(): void {
    this.questionToCopyFromCtrl.valueChanges.subscribe((questionId: string) => {
      this.questionToCopyFromCtrl.reset('', { emitEvent: false });

      if (this.activeQuestion().value.cards.filter((o) => o.text).length > 0) {
        const dialogRef = this.dialog.open(CopyCardsConfirmationComponent);

        dialogRef.afterClosed().subscribe((action) => {
          if (!action) {
            return;
          }

          this.patchCardsArray(questionId);
        });
      } else {
        this.patchCardsArray(questionId);
      }
    });
  }

  private patchCardsArray(questionId: string): void {
    this.cards.clear();

    const cardsToCopy = this.questionsToCopyCardsFrom.find((q) => q.id === questionId)?.cards || [];

    cardsToCopy.forEach((card) => {
      this.cards.push(new QuestionCardForm(card).form);
    });
  }
}
